import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'bmcore-good-item-page',
  templateUrl: './bmcore-good-item-page.component.html',
  styleUrls: ['./bmcore-good-item-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreGoodItemPageComponent {}
